import React from "react";

export const GitStats = () => {
  return (
    <section id="Skills" className="bg-black py-12 mb-9  ">
      <div className="container mx-auto text-center flex flex-col justify-center items-center ">
        {" "}
        <h2 className="section-title before:content-github relative before:absolute before:opacity-40 before:-top-7 before:-left-40 before:hidden before:lg:block ">
          Git-Stats
        </h2>
        <img
          style={{ width: "70%" }}
          src="https://github-readme-stats.vercel.app/api?username=Sandeep00022&show_icons=true&&countprivate=true&theme=react&hide_title=true"
          alt="GitHub Stats"
        />
        <img
          style={{ width: "70%" }}
          src="https://github-readme-streak-stats.herokuapp.com/?user=Sandeep00022&stroke=ffffff&background=1c1917&ring=0891b2&fire=0891b2&currStreakNum=ffffff&currStreakLabel=0891b2&sideNums=ffffff&sideLabels=ffffff&dates=ffffff&hide_border=true"
        />
      </div>
    </section>
  );
};
